import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

function rewriteNativeOverlayRoute(): void {
  const search = new URLSearchParams(window.location.search);
  if (search.get('jivuNativeRoute') !== 'overlay') return;

  const overlayToken = search.get('jivuOverlayToken');
  if (overlayToken) {
    (window as any).__HEYJIVU_OVERLAY_TOKEN__ = overlayToken;
  }

  const overlayBusNonce = search.get('jivuOverlayBusNonce');
  if (overlayBusNonce) {
    (window as any).__HEYJIVU_OVERLAY_BUS_NONCE__ = overlayBusNonce;
  }

  // Native wrappers open the root URL first so the relative base href stays rooted.
  window.history.replaceState(window.history.state, '', '/jivu-overlay');
}

rewriteNativeOverlayRoute();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
